/* eslint-disable react/prop-types */
import React from 'react'

import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconQuestion = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.189 25.194"
    {...props}
  >
    <g transform="translate(-50.804)">
      <g transform="translate(50.804)">
        <path
          d="M138.564 274.074h-4.724a.808.808 0 0 0-.787.788v4.724a.807.807 0 0 0 .787.787h4.724a.808.808 0 0 0 .788-.787v-4.724a.809.809 0 0 0-.788-.788z"
          transform="translate(-127.383 -255.179)"
        />
        <path
          d="M68.186 4.754a8.16 8.16 0 0 0-2.086-2.51A10.67 10.67 0 0 0 63.225.61 8.822 8.822 0 0 0 60.056 0a10.053 10.053 0 0 0-9.133 5.236.777.777 0 0 0-.108.551.766.766 0 0 0 .305.492l3.228 2.461a.943.943 0 0 0 .492.157.765.765 0 0 0 .61-.315 13.425 13.425 0 0 1 2.106-2.264 3.721 3.721 0 0 1 2.126-.571 3.644 3.644 0 0 1 2.116.63 1.779 1.779 0 0 1 .915 1.457 2.21 2.21 0 0 1-.492 1.5 4.854 4.854 0 0 1-1.654 1.1 8.312 8.312 0 0 0-2.814 2.136 4.585 4.585 0 0 0-1.279 3.08v.886a1.478 1.478 0 0 0 .207.738.591.591 0 0 0 .5.364h4.724a.685.685 0 0 0 .551-.306 1.03 1.03 0 0 0 .236-.639 2.681 2.681 0 0 1 .541-1.319 3.859 3.859 0 0 1 1.349-1.28q.767-.433 1.2-.7a9.97 9.97 0 0 0 1.132-.856A5.661 5.661 0 0 0 68 11.366a6.647 6.647 0 0 0 .994-3.494 6.448 6.448 0 0 0-.808-3.118z"
          transform="translate(-50.804)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconQuestion)
